export function sendPreparedMessage(messageId: string): void {
  if (typeof window !== "undefined" && window.Telegram?.WebApp) {
    const webApp: any = window.Telegram.WebApp;
    if (
      webApp.sendPreparedMessage &&
      typeof webApp.sendPreparedMessage === "function"
    ) {
      webApp.sendPreparedMessage(messageId);
      return;
    }
    const eventData = { id: messageId };
    if ((window as any).TelegramWebviewProxy?.postEvent) {
      (window as any).TelegramWebviewProxy.postEvent(
        "web_app_send_prepared_message",
        JSON.stringify(eventData),
      );
    } else if (window.parent && window.parent !== window) {
      const message = JSON.stringify({
        eventType: "web_app_send_prepared_message",
        eventData: eventData,
      });
      window.parent.postMessage(message, "https://web.telegram.org");
    } else {
      console.warn("Telegram Web App environment not detected");
    }
  } else {
    console.warn("Telegram Web App SDK not available");
  }
}

export function openTelegramLink(url: string): void {
  if (typeof window !== "undefined" && window.Telegram?.WebApp) {
    const webApp: any = window.Telegram.WebApp;
    
    // Try using the SDK method first if available
    if (webApp.openTelegramLink && typeof webApp.openTelegramLink === "function") {
      webApp.openTelegramLink(url);
      return;
    }
    
    // Use postEvent with web_app_open_tg_link
    const eventData = { url };
    if ((window as any).TelegramWebviewProxy?.postEvent) {
      (window as any).TelegramWebviewProxy.postEvent(
        "web_app_open_tg_link",
        JSON.stringify(eventData),
      );
    } else if (window.parent && window.parent !== window) {
      const message = JSON.stringify({
        eventType: "web_app_open_tg_link",
        eventData: eventData,
      });
      window.parent.postMessage(message, "https://web.telegram.org");
    } else {
      console.warn("Telegram Web App environment not detected");
      // Fallback to window.location
      try {
        window.location.href = url;
      } catch (error) {
        console.error("Error opening link:", error);
        window.open(url, "_blank");
      }
    }
  } else {
    console.warn("Telegram Web App SDK not available");
    // Fallback to window.location
    try {
      window.location.href = url;
    } catch (error) {
      console.error("Error opening link:", error);
      window.open(url, "_blank");
    }
  }
}
